<template>
  <div class="card modal-card is-min-width-500">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h3 class="title is-size-3">
            {{ $t('listeMaterielTlpe.popup.updateInfosTlpe.title') }}
          </h3>
        </div>
      </div>
    </div>
    <div class="modal-card-body">
      <div class="card-content overflow-x-hidden">
        <div class="columns is-vcentered">
          <b-field class=" column is-1 has-text-centered"
                   :label="$t('listeMaterielTlpe.popup.updateInfosTlpe.prisEnCompte')" />
          <div class="column is-10"></div>
          <b-field class="column is-1 has-text-centered"
                   :label="$t('listeMaterielTlpe.popup.updateInfosTlpe.faces')" />
        </div>
        <div class="columns is-vcentered"
            :class="{'has-background-info-light': isEtatApplyable }">
          <b-field class=" column is-1 has-text-centered">
            <qd-switch class="is-switch-centered" v-model="isEtatApplyable">
            </qd-switch>
          </b-field>
          <b-field class="column is-4 pdl-40px"
                   :label="$t('listeMaterielTlpe.popup.updateInfosTlpe.etat')" />
          <b-field class="column is-6">
            <b-select v-model="etatSelected" expanded
              @input="isEtatApplyable = true">
              <option v-for="etat in Etats"
                      :value="etat.value" :key="etat.value">
                {{ $t(etat.libelle) }}
              </option>
            </b-select>
          </b-field>
          <div class="column is-1 has-text-centered">
            <b-checkbox class="is-switch-centered" v-model="etatImpactFaces"/>
          </div>
        </div>
        <div class="columns is-vcentered"
          v-if="isEtatApplyable && etatSelected === etatDemonte">
          <b-field class=" column is-1 has-text-centered">
          </b-field>
          <b-field class="column is-4 pdl-40px"
           :label="$t('dispositifPublicitaire.popUpSave.commentaire')"/>
          <b-field class="column is-6">
            <textarea class="textarea"
              rows="2"
              v-model="commentaire">
            </textarea>
          </b-field>
        </div>
        <div class="columns is-vcentered"
              :class="{'has-background-info-light': isMontageApplyable }">
          <b-field class=" column is-1 has-text-centered">
            <qd-switch class="is-switch-centered" v-model="isMontageApplyable">
            </qd-switch>
          </b-field>
          <b-field class="column is-4 pdl-40px"
                   :label="$t('listeMaterielTlpe.popup.updateInfosTlpe.dateMontage')" />
          <b-field class="column is-6">
            <b-datepicker show-week-number
                          v-model="dateMontageSelected"
                          icon="calendar-today"
                          nearby-selectable-month-days
                          :editable="true"
                          @input="isMontageApplyable = true">
            </b-datepicker>
          </b-field>
          <div class="column is-1 has-text-centered">
            <b-checkbox class="is-switch-centered" v-model="dateMontageImpactFaces"/>
          </div>
        </div>
        <div
          class="columns is-vcentered"
          :class="{'has-background-info-light': isDemontageApplyable }">
          <b-field class=" column is-1 has-text-centered">
            <qd-switch class="is-switch-centered" v-model="isDemontageApplyable">
            </qd-switch>
          </b-field>
          <b-field class="column is-4 pdl-40px"
                   :label="$t('listeMaterielTlpe.popup.updateInfosTlpe.dateDemontage')" />
          <b-field class="column is-6">
            <b-datepicker show-week-number
                          v-model="dateDemontageSelected"
                          icon="calendar-today"
                          nearby-selectable-month-days
                          :editable="true"
                          @input="isDemontageApplyable = true">
            </b-datepicker>
          </b-field>
          <div class="column is-1 has-text-centered">
            <b-checkbox class="is-switch-centered" v-model="dateDemontageImpactFaces"/>
          </div>
        </div>
        <div class="columns is-vcentered"
            :class="{'has-background-info-light': isformatApplyable }">
          <b-field class="column is-1 has-text-centered">
            <qd-switch class="is-switch-centered" v-model="isformatApplyable">
            </qd-switch>
          </b-field>
          <b-field class="column is-4 pdl-40px"
                   :label="$t('listeMaterielTlpe.popup.updateInfosTlpe.format')" />
          <div class="column is-6">
            <parametre-autocomplete
              v-model="formatSelected"
              :target="PARAMETRES_KEYS.materielFormat"
              @input="isformatApplyable = true"
              expanded
            />
          </div>
          <div class="column is-1"></div>
        </div>
        <div class="columns is-vcentered"
            :class="{'has-background-info-light': isSurfaceApplyable }">
          <b-field class="column is-1 has-text-centered">
            <qd-switch class="is-switch-centered" v-model="isSurfaceApplyable">
            </qd-switch>
          </b-field>
          <b-field class="column is-4 pdl-40px"
                   :label="$t('listeMaterielTlpe.popup.updateInfosTlpe.surface')" />
          <b-field class="column is-6">
            <qd-numberinput v-model="surfaceSelected"
                           :controls="false" step="0.01"
                          @input="isSurfaceApplyable = true">
            </qd-numberinput>
          </b-field>
          <div class="column is-1"></div>
        </div>
        <div class="columns is-vcentered"
            :class="{'has-background-info-light': isCollectiviteApplyable }">
          <b-field class=" column is-1 has-text-centered">
            <qd-switch class="is-switch-centered" v-model="isCollectiviteApplyable">
            </qd-switch>
          </b-field>
          <b-field class="column is-4 pdl-40px"
                   :label="$t('listeMaterielTlpe.popup.updateInfosTlpe.collectivite')" />
          <b-field class="column is-6">
            <b-autocomplete :open-on-focus="false"
                            :data="collectiviteList"
                            :value="libelleCollectivite"
                            field="nomWithAdresseAndCompteComptable"
                            @input="getCollectivite"
                            icon="magnify"
                            :loading="isFetchingCollectivite"
                            @select="selectCollectivite">
              <template slot="empty">
                <div v-if="!isFetchingCollectivite">
                  {{$t('materiel.tlpe.actions.noResult')}}
                </div>
                <div v-else>
                  {{$t('materiel.tlpe.actions.searchEnCours')}}
                </div>
              </template>
            </b-autocomplete>
          </b-field>
          <div class="column is-1"></div>
        </div>
        <div class="columns is-vcentered"
            :class="{'has-background-info-light': isTaxationApplyable }">
          <b-field class=" column is-1 has-text-centered">
            <qd-switch class="is-switch-centered" v-model="isTaxationApplyable">
            </qd-switch>
          </b-field>
          <b-field class="column is-4 pdl-40px"
                   :label="$t('listeMaterielTlpe.popup.updateInfosTlpe.taxation')" />
          <b-field class="column is-6">
            <b-autocomplete :open-on-focus="false"
                            :data="typeTaxeTlpeList"
                            :value="libelleTaxation"
                            field="libelle"
                            @input="getTypeTaxation"
                            icon="magnify"
                            :loading="isFetchingTaxation"
                            @select="setInformationTlpe">
              <template slot="empty">
                <div v-if="!isFetchingTaxation">
                  {{$t('materiel.tlpe.actions.noResult')}}
                </div>
                <div v-else>
                  {{$t('materiel.tlpe.actions.searchEnCours')}}
                </div>
              </template>
            </b-autocomplete>
          </b-field>
          <div class="column is-1"></div>
        </div>
        <div class="columns is-vcentered"
            :class="{'has-background-info-light': isDeclarableApplyable }">
          <b-field class=" column is-1 has-text-centered">
            <qd-switch class="is-switch-centered" v-model="isDeclarableApplyable">
            </qd-switch>
          </b-field>
          <b-field class="column is-4 pdl-40px"
                   :label="$t('listeMaterielTlpe.popup.updateInfosTlpe.declarable')" />
          <b-field class="column is-6">
            <b-select v-model="declarableSelected"
                      @input="isDeclarableApplyable = true">
              <option :value="null"></option>
              <option :value="true"> {{ $t('general.oui') }}
              </option>
              <option :value="false"> {{ $t('general.non') }}
              </option>
            </b-select>
          </b-field>
          <div class="column is-1 has-text-centered">
            <b-checkbox class="is-switch-centered" v-model="declarableImpactFaces"/>
          </div>
        </div>
        <div class="columns is-vcentered"
              :class="{'has-background-info-light': isEclaireApplyable }">
          <b-field class=" column is-1 has-text-centered">
            <qd-switch class="is-switch-centered" v-model="isEclaireApplyable">
            </qd-switch>
          </b-field>
          <b-field class="column is-4 pdl-40px"
                   :label="$t('listeMaterielTlpe.popup.updateInfosTlpe.eclaire')" />
          <b-field class="column is-6">
            <b-select v-model="eclaireSelected"
                      @input="isEclaireApplyable = true">
              <option :value="null"></option>
              <option :value="true"> {{ $t('general.oui') }}
              </option>
              <option :value="false"> {{ $t('general.non') }}
              </option>
            </b-select>
          </b-field>
          <div class="column is-1"></div>
        </div>
        <div class="columns is-vcentered"
              :class="{'has-background-info-light': isDescriptionTlpeApplyable }">
          <b-field class=" column is-1 has-text-centered">
            <qd-switch class="is-switch-centered" v-model="isDescriptionTlpeApplyable">
            </qd-switch>
          </b-field>
          <b-field class="column is-4 pdl-40px"
                   :label="$t('listeMaterielTlpe.popup.updateInfosTlpe.descriptionTlpe')"/>
          <b-field class="column is-6">
            <b-select v-model="descriptionTlpeSelected" expanded
                      @input="isDescriptionTlpeApplyable = true">
              <option v-for="description in descriptionsTlpe"
                      :value="description.code" :key="description.code">
                {{ $t(description.libelle) }}
              </option>
            </b-select>
          </b-field>
          <div class="column is-1"></div>
        </div>
        <div class="columns is-vcentered"
            :class="{'has-background-info-light': isEtatMontageTlpeApplyable }">
          <b-field class=" column is-1 has-text-centered">
            <qd-switch class="is-switch-centered" v-model="isEtatMontageTlpeApplyable">
            </qd-switch>
          </b-field>
          <b-field class="column is-4 pdl-40px"
                   :label="$t('listeMaterielTlpe.popup.updateInfosTlpe.etatMontageTlpe')"/>
          <b-field class="column is-6">
            <b-select v-model="etatMontageTlpeSelected" expanded
                      @input="isEtatMontageTlpeApplyable = true">
              <option v-for="etat in etatsFilDeLeauTlpe"
                      :value="etat.code" :key="etat.code">
                {{ $t(etat.libelle) }}
              </option>
            </b-select>
          </b-field>
          <div class="column is-1"></div>
        </div>
        <div class="columns is-vcentered"
            :class="{'has-background-info-light': isEtatDemontageTlpeApplyable }">
          <b-field class=" column is-1 has-text-centered">
            <qd-switch class="is-switch-centered" v-model="isEtatDemontageTlpeApplyable">
            </qd-switch>
          </b-field>
          <b-field class="column is-4 pdl-40px"
                   :label="$t('listeMaterielTlpe.popup.updateInfosTlpe.etatDemontageTlpe')"/>
          <b-field class="column is-6">
            <b-select v-model="etatDemontageTlpeSelected" expanded
                      @input="isEtatDemontageTlpeApplyable = true">
              <option v-for="etat in etatsFilDeLeauTlpe"
                      :value="etat.code" :key="etat.code">
                {{ $t(etat.libelle) }}
              </option>
            </b-select>
          </b-field>
          <div class="column is-1"></div>
        </div>
      </div>
      <footer class="mgt-20px">
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="applyUpdates()"
               :disabled='!hasSomethingToApply'>
              {{ $t('general.button.apply')}}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import messageErreur from '@/services/general/messageErreur';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { ETAT_DISPOSITIF_PUBLICITAIRE, DEMONTE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import debounce from 'lodash/debounce';
import { getAll } from '@/api/tiers';
import { TIERS_SOUS_TYPE_COLLECTIVITE, TIERS_TYPE_FOURNISSEUR } from '@/configuration/tiers/tiersConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import { getAll as getAllTypeTaxationTlpe } from '@/api/typeTaxationTlpe';
import formatDateIso from '@/services/general/formatIsoDate';
import { LISTE_ETAT_FIL_DE_LEAU } from '@/configuration/gabed/materiel/materielConf';
import { LISTE_DESCRIPTION_TLPE } from '@/configuration/gabed/tlpe/tlpeConf';
import ParametreAutocomplete from '@/components/general/autocomplete/parametreAutocomplete';

const Societe = createNamespacedHelpers('societe');

export default {
  name: 'popupUpdateTlpeInfos',
  components: {
    ParametreAutocomplete,
  },
  data() {
    return {
      Etats: ETAT_DISPOSITIF_PUBLICITAIRE,
      etatSelected: null,
      dateMontageSelected: null,
      dateDemontageSelected: null,
      formatSelected: null,
      surfaceSelected: null,
      collectiviteSelected: null,
      taxationSelected: null,
      declarableSelected: null,
      eclaireSelected: null,
      isEtatApplyable: false,
      isMontageApplyable: false,
      isDemontageApplyable: false,
      isformatApplyable: false,
      isSurfaceApplyable: false,
      isCollectiviteApplyable: false,
      isTaxationApplyable: false,
      isDeclarableApplyable: false,
      isEclaireApplyable: false,
      libelleCollectivite: null,
      isFetchingCollectivite: false,
      collectiviteList: [],
      isFetchingTaxation: false,
      typeTaxeTlpeList: [],
      libelleTaxation: null,
      etatImpactFaces: true,
      dateMontageImpactFaces: true,
      dateDemontageImpactFaces: true,
      declarableImpactFaces: true,
      isDescriptionTlpeApplyable: false,
      descriptionTlpeSelected: null,
      descriptionsTlpe: LISTE_DESCRIPTION_TLPE,
      isEtatMontageTlpeApplyable: false,
      etatMontageTlpeSelected: null,
      isEtatDemontageTlpeApplyable: false,
      etatDemontageTlpeSelected: null,
      etatsFilDeLeauTlpe: LISTE_ETAT_FIL_DE_LEAU,
      commentaire: null,
      etatDemonte: DEMONTE,
      PARAMETRES_KEYS,
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    hasSomethingToApply() {
      return this.isEtatApplyable
        || this.isMontageApplyable
        || this.isDemontageApplyable
        || this.isformatApplyable
        || this.isSurfaceApplyable
        || this.isCollectiviteApplyable
        || this.isTaxationApplyable
        || this.isDeclarableApplyable
        || this.isEclaireApplyable
        || this.isDescriptionTlpeApplyable
        || this.isEtatMontageTlpeApplyable
        || this.isEtatDemontageTlpeApplyable;
    },
  },
  methods: {
    getFormattageCollectivite(collectivite) {
      let libelle = collectivite.code + ' - ' + collectivite.nomCommercial;
      if (adressFullStringGetter(collectivite.adressePostale, false) !== '') {
        libelle += ' - ' + adressFullStringGetter(collectivite.adressePostale, false);
      }
      if (collectivite.compteComptable) {
        libelle += ' - ' + collectivite.compteComptable;
      }
      return libelle;
    },
    getCollectivite: debounce(async function collectiviteData(text) {
      if (text === this.libelleCollectivite) return;
      try {
        this.libelleCollectivite = text;
        this.isFetchingCollectivite = true;
        this.collectiviteSelected = null;
        const collectiviteList = (await getAll({
          query: {
            type: TIERS_TYPE_FOURNISSEUR,
            auto: text,
            sousType: [TIERS_SOUS_TYPE_COLLECTIVITE],
            archive: false,
            societeId: this.societeActiveId,
          },
        })).data.result.items;
        collectiviteList.map((collectivite) => {
          collectivite
            .nomWithAdresseAndCompteComptable = this.getFormattageCollectivite(collectivite);
          return collectivite;
        });
        this.collectiviteList = collectiviteList.filter((collectivite) => {
          return this.collectiviteSelected !== collectivite.id;
        });
        this.isFetchingCollectivite = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetchingCollectivite = false;
        throw e;
      }
    }, 500),
    selectCollectivite(data) {
      if (data) {
        this.collectiviteSelected = cloneDeep(data.id);
        this.libelleCollectivite = cloneDeep(data.nomWithAdresseAndCompteComptable);
        this.isCollectiviteApplyable = true;
      }
    },
    setInformationTlpe(data) {
      if (data) {
        this.libelleTaxation = data.libelle;
        this.taxationSelected = cloneDeep(data.id);
        this.isTaxationApplyable = true;
      }
    },
    getTypeTaxation: debounce(async function tlpeTaxationData(text) {
      if (!text) {
        this.taxationSelected = null;
        return;
      }
      if (this.libelleTaxation === text) return;
      try {
        this.libelleTaxation = text;
        this.taxationSelected = null;
        this.isFetchingTaxation = true;
        this.typeTaxeTlpeList = (await getAllTypeTaxationTlpe({
          query: { societeId: this.societeActiveId, auto: text, actif: true },
          limit: NO_PAGINATION,
        })).data.result.items;
        this.isFetchingTaxation = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetchingTaxation = false;
        throw e;
      }
    }, 500),
    applyUpdates() {
      if (!this.hasSomethingToApply) return;
      const args = [];
      if (this.isEtatApplyable && this.etatSelected !== null) {
        args.push({
          field: 'etat',
          value: this.etatSelected,
          impacterFaces: this.etatImpactFaces,
          commentaire: this.commentaire,
        });
      }
      if (this.isMontageApplyable) {
        args.push({
          field: 'dateMontage',
          value: formatDateIso(this.dateMontageSelected),
          impacterFaces: this.dateMontageImpactFaces,
        });
      }
      if (this.isDemontageApplyable) {
        args.push({
          field: 'dateDemontage',
          value: formatDateIso(this.dateDemontageSelected),
          impacterFaces: this.dateDemontageImpactFaces,
        });
      }
      if (this.isformatApplyable && this.formatSelected !== null) {
        args.push({
          field: 'formatId',
          value: this.formatSelected,
          impacterFaces: false,
        });
      }
      if (this.isSurfaceApplyable) {
        args.push({
          field: 'surfaceTlpe',
          value: this.surfaceSelected,
          impacterFaces: false,
        });
      }
      if (this.isCollectiviteApplyable) {
        args.push({
          field: 'collectiviteId',
          value: this.collectiviteSelected,
          impacterFaces: false,
        });
      }
      if (this.isTaxationApplyable) {
        args.push({
          field: 'typeTaxationId',
          value: this.taxationSelected,
          impacterFaces: false,
        });
      }
      if (this.isDeclarableApplyable) {
        args.push({
          field: 'declarable',
          value: this.declarableSelected,
          impacterFaces: this.declarableImpactFaces,
        });
      }
      if (this.isEclaireApplyable) {
        args.push({
          field: 'eclaire',
          value: this.eclaireSelected,
          impacterFaces: false,
        });
      }
      if (this.isDescriptionTlpeApplyable && this.descriptionTlpeSelected !== null) {
        args.push({
          field: 'descriptionTlpe',
          value: this.descriptionTlpeSelected,
          impacterFaces: false,
        });
      }
      if (this.isEtatMontageTlpeApplyable && this.etatMontageTlpeSelected !== null) {
        args.push({
          field: 'etatMontageTlpe',
          value: this.etatMontageTlpeSelected,
          impacterFaces: false,
        });
      }
      if (this.isEtatDemontageTlpeApplyable && this.etatDemontageTlpeSelected !== null) {
        args.push({
          field: 'etatDemontageTlpe',
          value: this.etatDemontageTlpeSelected,
          impacterFaces: false,
        });
      }
      this.$emit('updateMateriel', args);
    },
  },
};
</script>
